var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttendancePercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7727 15.8802C25.2996 15.4071 24.5372 15.4071 24.0641 15.8802L15.9411 24.0032C15.468 24.4763 15.468 25.2387 15.9411 25.7118C16.1777 25.9483 16.4933 26.0536 16.8086 26.0536C17.124 26.0536 17.4396 25.9485 17.6761 25.7118L25.7991 17.5888C26.246 17.1157 26.246 16.3535 25.7727 15.8802Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.043 17.0104C19.043 18.0992 18.1603 18.982 17.0714 18.982C15.9826 18.982 15.0999 18.0992 15.0999 17.0104C15.0999 15.9214 15.9826 15.0388 17.0714 15.0388C18.1603 15.0388 19.043 15.9214 19.043 17.0104Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6138 24.5812C26.6138 25.67 25.7311 26.5528 24.6422 26.5528C23.5534 26.5528 22.6707 25.67 22.6707 24.5812C22.6707 23.4924 23.5534 22.6096 24.6422 22.6096C25.7311 22.6096 26.6138 23.4924 26.6138 24.5812Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3847 12.6204L19.9893 10.9906C20.1207 10.6488 19.8578 10.2808 19.4897 10.2808H8.02822C6.18812 10.2808 4.66337 11.6478 4.47927 13.4879L4.00618 17.8517C3.95355 18.2724 4.24273 18.6666 4.66337 18.7719C5.13646 18.877 5.76747 18.956 6.39842 19.0348L6.79267 25.9748C6.81889 26.5532 7.31838 27.0001 7.89676 27.0001H11.2354C11.8137 27.0001 12.2868 26.5532 12.3395 25.9748L12.9442 14.0401C12.9442 13.4356 13.4437 12.9623 14.0221 12.9623H18.8853C19.1217 12.9623 19.3058 12.8308 19.3847 12.6205L19.3847 12.6204Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2596 5.65402C13.2596 7.67199 11.6235 9.30803 9.60556 9.30803C7.5874 9.30803 5.95154 7.67199 5.95154 5.65402C5.95154 3.63605 7.5874 2 9.60556 2C11.6235 2 13.2596 3.63605 13.2596 5.65402Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendancePercentage);
export default __webpack_public_path__ + "static/media/AttendancePercentage.fd38918cd74397f41158b77c76c786b3.svg";
export { ForwardRef as ReactComponent };